import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  addEquipmentManager,
  addPharmacyManager,
  getAllUserArea,
  getUserInArea,
  putAddDispatcher,
  putAddInsurancer,
  putAddMujahidArea,
  putAddTrainer,
  putFinalize,
  removeDispatcher,
  removeEquipmentManager,
  removeInsurancer,
  removePharmacyManager,
  removeTrainer,
  _deleteUserFromArea,
} from "../../../api/area";
import TrashIcon from "../../../assets/SVG/trashIcon";
import CustomizedHook from "../../project/autocomplatePro";
import ButtonNextLevel from "../../signin/buttonNextLevel";

export default function LevelTwoArea({
  level,
  setLevel,
  dataUserSelected,
  setDataUserSelected,
  areaId,
  handleOpen,
  handleClose,
  update,
}) {
  const [dataAllUser, setDataAllUser] = useState();
  const [newItems, setNewItems] = useState([]); // برای نگهداری آیتم‌های جدید اضافه شده

  const dataTitr = [
    "نام و نام خانوادگی",
    "کدملی",
    "رشته تحصیلی",
    "شماره تلفن",
    "عملیات",
  ];

  useEffect(() => {
    if (areaId) {
      if (level === 2) {
        getAllUserArea()
          .then((x) => setDataAllUser(x))
          .catch(() => {});
      } else {
        getUserInArea(areaId)
          .then((x) => setDataAllUser(x))
          .catch(() => {});
      }
    }
  }, [areaId]);

  const handleDelete = (id) => {
    // بررسی آیا آیتم جدید است یا قدیمی
    const isNewItem = newItems.some((item) => item.id === id);

    if (isNewItem) {
      // اگر آیتم جدید است، فقط از state حذف می‌شود
      const updatedData = dataUserSelected.filter((item) => item.id !== id);
      const updatedNewItems = newItems.filter((item) => item.id !== id);
      setDataUserSelected(updatedData);
      setNewItems(updatedNewItems);
    } else {
      // اگر آیتم قدیمی است، همیشه درخواست به بک‌اند ارسال می‌شود (مستقل از update)
      if (level === 2) {
        _deleteUserFromArea(areaId, id)
          .then(() => {
            const updatedData = dataUserSelected.filter(
              (item) => item.id !== id
            );
            setDataUserSelected(updatedData);
          })
          .catch(() => {});
      }
      if (level === 5) {
        removeTrainer(areaId, id)
          .then(() => {
            const updatedData = dataUserSelected.filter(
              (item) => item.id !== id
            );
            setDataUserSelected(updatedData);
          })
          .catch(() => {});
      }
      if (level === 6) {
        removeDispatcher(areaId, id)
          .then(() => {
            const updatedData = dataUserSelected.filter(
              (item) => item.id !== id
            );
            setDataUserSelected(updatedData);
          })
          .catch(() => {});
      }
      if (level === 7) {
        removeInsurancer(areaId, id)
          .then(() => {
            const updatedData = dataUserSelected.filter(
              (item) => item.id !== id
            );
            setDataUserSelected(updatedData);
          })
          .catch(() => {});
      }
      if (level === 8) {
        removePharmacyManager(areaId, id)
          .then(() => {
            const updatedData = dataUserSelected.filter(
              (item) => item.id !== id
            );
            setDataUserSelected(updatedData);
          })
          .catch(() => {});
      }
      if (level === 9) {
        removeEquipmentManager(areaId, id)
          .then(() => {
            const updatedData = dataUserSelected.filter(
              (item) => item.id !== id
            );
            setDataUserSelected(updatedData);
          })
          .catch(() => {});
      }
    }
  };

  return (
    <>
      <Box>
        <CustomizedHook
          width={"50vw"}
          notShowValue
          placeholder={"جهادگران را انتخاب کنید."}
          label="جهادگران"
          options={dataAllUser}
          onChange={(event, newValue) => {
            // جلوگیری از تکراری بودن آیتم‌ها بر اساس ID
            const merged = [...dataUserSelected, ...newValue].filter(
              (item, index, self) =>
                index === self.findIndex((i) => i.id === item.id)
            );
            setDataUserSelected(merged);
            // اضافه کردن آیتم‌های جدید به state جداگانه
            const addedItems = newValue.filter(
              (item) =>
                !dataUserSelected.some((existing) => existing.id === item.id)
            );
            setNewItems((prev) => [...prev, ...addedItems]);
          }}
        />
        <Box
          width="calc( 93% - 40px )"
          p="10px 20px"
          mt="20px"
          sx={{ height: "44vh", overflow: "auto" }}
          bgcolor="#F5F9FF"
          borderRadius={"9px"}
        >
          <Typography
            fontSize="14px"
            fontWeight={"bold"}
            color="var(--emr-darkblue)"
          >
            جدول جهادگران
          </Typography>
          <Box display="flex" mt="10px">
            {dataTitr.map((x) => (
              <Typography width="100%" fontSize="12px" color="var(--emr-gray)">
                {x}
              </Typography>
            ))}
          </Box>
          {dataUserSelected?.map((x, i) => (
            <Box display={"flex"} alignItems="center">
              <Typography
                mt="20px"
                width={"100%"}
                fontWeight="bold"
                fontSize="12px"
                color="var(--emr-font)"
              >
                {x.name}
              </Typography>
              <Typography
                mt="20px"
                width={"100%"}
                fontWeight="bold"
                fontSize="12px"
                color="var(--emr-font)"
              >
                {x.nid}
              </Typography>
              <Typography
                mt="20px"
                width={"100%"}
                fontWeight="bold"
                fontSize="12px"
                color="var(--emr-font)"
              >
                {x.field}
              </Typography>
              <Typography
                mt="20px"
                width={"100%"}
                fontWeight="bold"
                fontSize="12px"
                color="var(--emr-font)"
              >
                {x.phone}
              </Typography>

              <Box
                mt="20px"
                width={"100%"}
                fontWeight="bold"
                fontSize="12px"
                color="var(--emr-font)"
              >
                <Box
                  pt="5px"
                  px="7px"
                  height="fit-content"
                  bgcolor="#EEEEEE"
                  width={"fit-content"}
                  borderRadius="5px"
                  sx={{
                    cursor: "pointer",
                    ":hover": {
                      bgcolor: "",
                    },
                  }}
                  onClick={() => handleDelete(x.id)}
                >
                  <TrashIcon />
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <Box display="flex" justifyContent={"end"}>
        <ButtonNextLevel
          setLevel={setLevel}
          level={level}
          handleClickBack={() => {
            setDataUserSelected([]);
            setNewItems([]);
          }}
          onClickNextLevel={() => {
            const items = JSON.parse(localStorage.getItem("levelPopArea"));
            if (level === 2) {
              putAddMujahidArea(
                areaId,
                dataUserSelected.map((x) => x.id)
              )
                .then(() => {
                  setLevel(3);
                  setDataUserSelected([]);
                  setNewItems([]);
                  if (items !== 10) {
                    localStorage.setItem("levelPopArea", JSON.stringify(3));
                  }
                })
                .catch(() => {});
            }
            if (level === 6) {
              putAddDispatcher(
                areaId,
                dataUserSelected.map((x) => x.id)
              )
                .then(() => {
                  setLevel(7);
                  setDataUserSelected([]);
                  setNewItems([]);
                  if (items !== 10) {
                    localStorage.setItem("levelPopArea", JSON.stringify(7));
                  }
                })
                .catch(() => {});
            }
            if (level === 5) {
              putAddTrainer(
                areaId,
                dataUserSelected.map((x) => x.id)
              )
                .then(() => {
                  setLevel(6);
                  setDataUserSelected([]);
                  setNewItems([]);
                  if (items !== 10) {
                    localStorage.setItem("levelPopArea", JSON.stringify(6));
                  }
                })
                .catch(() => {});
            }
            if (level === 7) {
              putAddInsurancer(
                areaId,
                dataUserSelected.map((x) => x.id)
              )
                .then(() => {
                  setLevel(8);
                  setDataUserSelected([]);
                  setNewItems([]);
                  if (items !== 10) {
                    localStorage.setItem("levelPopArea", JSON.stringify(8));
                  }
                })
                .catch(() => {});
            }
            if (level === 8) {
              addPharmacyManager(
                areaId,
                dataUserSelected.map((x) => x.id)
              )
                .then(() => {
                  setLevel(9);
                  setDataUserSelected([]);
                  setNewItems([]);
                  if (items !== 10) {
                    localStorage.setItem("levelPopArea", JSON.stringify(9));
                  }
                })
                .catch(() => {});
            }
            if (level === 9) {
              addEquipmentManager(
                areaId,
                dataUserSelected.map((x) => x.id)
              )
                .then(() => {
                  putFinalize(areaId)
                    .then(() => {
                      if (items !== 10) {
                        localStorage.setItem(
                          "levelPopArea",
                          JSON.stringify(10)
                        );
                      }
                      handleClose();
                      handleOpen();
                    })
                    .catch(() => {});
                })
                .catch(() => {});
            }
          }}
        />
      </Box>
    </>
  );
}
